<template>
    <div class="row" v-if="form.id">
        <div class="col-md-10">
            <div class="row">
                <div class="col-md-5 mt-2">
                    <label class="form-label" for="title">Title</label>
                    <input
                        type="text" v-model="form.title"
                        class="form-control"
                        :class="hasError('title') ? 'is-invalid' : ''"
                        id="title"
                        name="title"
                    >
                    <span
                        class="mt-2 text-danger"
                        v-if="hasError('title')">
                                    {{ getError('title') }}
                            </span>
                </div>
                <div class="col-md-5 mt-2">
                    <label class="form-label" for="business_name">Business name</label>
                    <input
                        type="text" v-model="form.business_name"
                        class="form-control"
                        :class="hasError('business_name') ? 'is-invalid' : ''"
                        id="business_name"
                        name="business_name"
                    >
                    <span
                        class="mt-2 text-danger"
                        v-if="hasError('business_name')">
                                    {{ getError('business_name') }}
                            </span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5 mt-2">
                    <label class="form-label" for="vat_number">VAT number</label>
                    <input
                        type="text" v-model="form.vat_number"
                        class="form-control"
                        :class="hasError('vat_number') ? 'is-invalid' : ''"
                        id="vat_number"
                        name="vat_number"
                    >
                    <span
                        class="mt-2 text-danger"
                        v-if="hasError('vat_number')">
                                    {{ getError('vat_number') }}
                            </span>
                </div>
                <div class="col-md-5 mt-2">
                    <label class="form-label" for="vat_rate">VAT rate (%)</label>
                    <input
                        type="number"
                        min="0"
                        v-model="form.vat_rate"
                        class="form-control"
                        :class="hasError('vat_rate') ? 'is-invalid' : ''"
                        id="vat_rate"
                        name="vat_rate"
                    >
                    <span
                        class="mt-2 text-danger"
                        v-if="hasError('vat_rate')">
                                    {{ getError('vat_rate') }}
                            </span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5 mt-2">
                    <label class="form-label" for="country">Country</label>
                    <select class="form-select" :class="hasError('order_reschedule_interval_id') ? 'is-invalid' : ''" v-model="form.country">
                        <option v-for="country in countries" :value="country.name">{{ country.name }}</option>
                    </select>
                    <span class="mt-2 text-danger" v-if="hasError('country')">
                                {{ getError('country') }}
                            </span>
                </div>
                <div class="col-md-5 mt-2">
                    <label class="form-label" for="city">City</label>
                    <input
                        type="text" v-model="form.city"
                        class="form-control"
                        :class="hasError('city') ? 'is-invalid' : ''"
                        id="city"
                        name="city"
                    >
                    <span
                        class="mt-2 text-danger"
                        v-if="hasError('city')">
                                    {{ getError('city') }}
                            </span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5 mt-2">
                    <label class="form-label" for="address">Address</label>
                    <input
                        type="text" v-model="form.address"
                        class="form-control"
                        :class="hasError('address') ? 'is-invalid' : ''"
                        id="address"
                        name="address"
                    >
                    <span class="mt-2 text-danger" v-if="hasError('address')">
                                {{ getError('address') }}
                            </span>
                </div>
                <div class="col-md-5 mt-2">
                    <label class="form-label" for="post_code">Postal Code</label>
                    <input
                        type="text" v-model="form.post_code"
                        class="form-control"
                        :class="hasError('post_code') ? 'is-invalid' : ''"
                        id="post_code"
                        name="post_code"
                    >
                    <span class="mt-2 text-danger" v-if="hasError('post_code')">
                                {{ getError('post_code') }}
                            </span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5 mt-2">
                    <label class="form-label" for="phone">Phone</label>
                    <vue-tel-input
                        style="height: 46px;"
                        v-model="form.phone"
                        class="form-control"
                        :class="hasError('phone') ? 'is-invalid' : ''">
                    </vue-tel-input>
                    <span class="mt-2 text-danger" v-if="hasError('phone')">
                                {{ getError('phone') }}
                            </span>
                </div>
                <div class="col-md-5 mt-2">
                    <label class="form-label" for="website">Website</label>
                    <input
                        type="text" v-model="form.website"
                        class="form-control"
                        :class="hasError('website') ? 'is-invalid' : ''"
                        id="website"
                        name="website"
                    >
                    <span class="mt-2 text-danger" v-if="hasError('website')">
                                {{ getError('website') }}
                            </span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-5 mt-2">
                    <label class="form-label">Public URL</label>
                    <input
                        type="text" v-model="form.public_url"
                        class="form-control"
                        :class="hasError('public_url') ? 'is-invalid' : ''"
                        id="public_url"
                        name="public_url"
                    >
                    <span
                        class="mt-2 text-danger"
                        v-if="hasError('public_url')">
                                    {{ getError('public_url') }}
                            </span>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-12 mt-2 pb-3">
                    <button type="submit" class="btn btn-primary float-end" @click="updateSettings">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Form from "../helpers/Form";
import Notification from "../helpers/Notification";

export default {
    mixins: [Form],
    props: {},
    data() {
        return {
            // form data (current form values)
            form: {},
            countries: [],
        };
    },
    watch: {
        success: function (value, oldValue) {
            if (value) {
                this.getSettings();
            }
        },
    },
    methods: {
        getCountries() {
            axios.get('/api/countries'
            )
                .then(res => {
                    this.countries = res.data;
                })
                .catch((error) => {
                    console.log(error.response.data.message);
                });
        },
        getSettings() {
            this.errors = {};
            axios.get('/api/admin/settings?type=company').then(res => {
                    this.form = res.data.data;
                }
            );
        },
        updateSettings() {
            this.form.type = 'company'
            axios.put('/api/admin/settings-company', this.form)
                .then(res => {
                    Notification.methods.success(res.data.message);
                    this.errors = {};
                })
                .catch((error) => {
                    if(error && error.response.status === 422) {
                        this.setErrors(error.response.data.errors);
                    }else {
                        this.onFailure(error.response.data.message);
                    }
                });
        },
        onlyNumbers(e) {
            e = (e) ? e : window.event;
            let charCode = (e.which) ? e.which : e.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                e.preventDefault();
            } else {
                return true;
            }
        },
    },
    mounted() {
        //table get data
        this.getCountries();
        this.getSettings();
    }
}
</script>

<style scoped>
.form-label {
    margin-left: 5px;
}
</style>
